import React, { useState } from "react";
import { Card, Button, Dropdown } from 'react-bootstrap';
import { FaLink, FaFileAlt, FaRegStickyNote, FaUserPlus, FaClipboardList, FaTrash, FaRegEdit, FaChartLine, FaCheck, FaTimes, FaHistory, FaReceipt, FaEye } from "react-icons/fa";
import { formataDataExibicao, formataDataHoraExibicao, situacoesAgendamento, hasPerm, agendamentoEncerrado } from '../../../common/utils';
import AcoesLinkPaciente from '../../Meetings/AcoesLinkPaciente';
import { semData, ESTILO_METADADO, ESTILO_ROTULO_FILTRO, ESTILO_INPUT_FILTRO, ESTILO_SELECT_FILTRO } from './tokens';

const GRADE = '72px 150px 1fr 190px 130px 120px 150px';


// Lista de agendamentos com o ruído reduzido (design 1c): mesma densidade da aba
// atual, mas 1 ação por linha, vínculos como texto e datas secundárias no tooltip.
const AgendamentosBeta = ({
    agendamentos = [],
    dadosUsuario = {},
    podeAgendar = false,
    podeVerVinculo = false,
    recebeKit = false,
    podeVincularExame = () => false,
    onAgendarServico,
    onConfirmarRealizacao,
    onEditar,
    onVincularExame,
    onGerarServico,
    onArquivos,
    onMonitoramento,
    onAnotacoes,
    onAtribuirPrestador,
    onFormularioDinamico,
    onExcluir,
    onVisualizar,
    onAceite,
    onHistoricoAceites,
    onDespesas,
    habilitarAceiteRecusa = false,
    habilitarDespesas = false,
    podeEditarComoPrestador = true,
    mostrarFormularioDinamico = () => false,
    emailPaciente,
    carregando = false,
    filtros = {},
    total = 0,
    pagina = 1,
    porPagina = 20,
    opcoesFiltro = { situacoes: [], servicos: [], prestadores: [] },
    onFiltrar,
    onPagina,
}) => {
    // Status, serviço e prestador são recortes de gestão: quem opera a carteira e quem
    // administra. O prestador vê apenas o que é dele, então esses filtros só o atrapalham.
    const perfil = dadosUsuario['tipo_usuario'];
    const podeFiltrarGestao = dadosUsuario['is_superuser'] === true
        || perfil === 'operador'
        || perfil === ''
        || (perfil === 'gestor' && dadosUsuario['tipo_gestor'] === 'interno');
    // A busca digita local e só vai à API no Enter ou no botão, para não disparar uma
    // consulta por tecla. Os demais filtros consultam ao mudar.
    const [busca, setBusca] = useState(filtros.search || '');

    const aplicar = (mudanca) => onFiltrar && onFiltrar({ ...filtros, search: busca, ...mudanca });

    const temFiltro = filtros.situacao || filtros.servico_procedimento_id || filtros.prestador_id
        || filtros.data_inicio || filtros.data_fim || filtros.search;

    const limparFiltros = () => {
        setBusca('');
        onFiltrar && onFiltrar({ situacao: '', servico_procedimento_id: '', prestador_id: '', data_inicio: '', data_fim: '', search: '' });
    };

    const visiveis = agendamentos;
    const totalPaginas = Math.max(1, Math.ceil(total / porPagina));

    const aguardando = agendamentos.filter(ag =>
        !['finalizado', 'cancelado', 'arquivo_pendente'].includes(ag.situacao)
        && (ag.status_aceite === 'aceito' || !ag.envia_aceite)
    ).length;

    const grade = recebeKit ? GRADE : GRADE.replace(' 120px', '');

    // "Enviado 24/08" numa linha; previsão e status completo ficam no tooltip.
    const resumoKit = (ag) => {
        const kit = ag.dados_atendimento_kit;
        if (!kit) return { texto: '—', titulo: 'Sem envio de kit' };

        const partes = [
            kit.data_envio ? `Previsão ${formataDataExibicao(kit.data_envio)}` : null,
            kit.data_envio_realizado ? `Enviado em ${formataDataExibicao(kit.data_envio_realizado)}` : null,
        ].filter(Boolean);

        if (kit.data_envio_realizado) {
            return { texto: `Enviado ${formataDataExibicao(kit.data_envio_realizado).slice(0, 5)}`, titulo: partes.join(' · ') };
        }
        return { texto: kit.data_envio ? 'Previsto' : 'Sim', titulo: partes.join(' · ') || 'Envio de kit' };
    };

    return (
        <Card className="cardDestaque mt-4">
            <Card.Body className="p-0">
                <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap" style={{ padding: '16px 20px', borderBottom: '1px solid #e6ecf3' }}>
                    <div className="d-flex align-items-baseline gap-2">
                        <div style={{ fontSize: '17px', fontWeight: 700, color: '#0f2748' }}>Agendamentos de Serviços</div>
                        <div style={{ fontSize: '13px', color: '#6b7a8d' }}>
                            {carregando ? 'carregando…' : `${total} ${total === 1 ? 'resultado' : 'resultados'}`}
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        {aguardando > 0 && (
                            <span style={{ fontSize: '12px', fontWeight: 600, color: '#8a6a1f', background: '#fdf3dd', borderRadius: '20px', padding: '5px 11px' }}>
                                {aguardando} aguardando realização
                            </span>
                        )}
                        {podeAgendar && (
                            <Button variant="success" size="sm" onClick={onAgendarServico}>Agendar serviço</Button>
                        )}
                    </div>
                </div>

                <div className="d-flex align-items-end gap-2 flex-wrap" style={{ padding: '12px 20px', background: '#f7fafc', borderBottom: '1px solid #e6ecf3' }}>
                    {podeFiltrarGestao && (
                    <>
                    <div>
                        <label style={ESTILO_ROTULO_FILTRO}>Status</label>
                        <select className="form-select form-select-sm" style={{ ...ESTILO_SELECT_FILTRO, width: '160px' }} value={filtros.situacao || ''} onChange={(e) => aplicar({ situacao: e.target.value })}>
                            <option value="">Todos</option>
                            {opcoesFiltro.situacoes.map(s => <option key={s} value={s}>{situacoesAgendamento[s] || s}</option>)}
                        </select>
                    </div>
                    <div>
                        <label style={ESTILO_ROTULO_FILTRO}>Serviço</label>
                        <select className="form-select form-select-sm" style={{ ...ESTILO_SELECT_FILTRO, width: '220px' }} value={filtros.servico_procedimento_id || ''} onChange={(e) => aplicar({ servico_procedimento_id: e.target.value })}>
                            <option value="">Todos</option>
                            {opcoesFiltro.servicos.map(([id, nome]) => <option key={id} value={id}>{nome}</option>)}
                        </select>
                    </div>
                    <div>
                        <label style={ESTILO_ROTULO_FILTRO}>Prestador</label>
                        <select className="form-select form-select-sm" style={{ ...ESTILO_SELECT_FILTRO, width: '200px' }} value={filtros.prestador_id || ''} onChange={(e) => aplicar({ prestador_id: e.target.value })}>
                            <option value="">Todos</option>
                            {opcoesFiltro.prestadores.map(([id, nome]) => <option key={id} value={id}>{nome}</option>)}
                        </select>
                    </div>
                    </>
                    )}
                    <div>
                        <label style={ESTILO_ROTULO_FILTRO}>Data de</label>
                        <input type="date" className="form-control form-control-sm" style={{ ...ESTILO_INPUT_FILTRO, width: '150px' }} value={filtros.data_inicio || ''} onChange={(e) => aplicar({ data_inicio: e.target.value })} />
                    </div>
                    <div>
                        <label style={ESTILO_ROTULO_FILTRO}>até</label>
                        <input type="date" className="form-control form-control-sm" style={{ ...ESTILO_INPUT_FILTRO, width: '150px' }} value={filtros.data_fim || ''} onChange={(e) => aplicar({ data_fim: e.target.value })} />
                    </div>
                    <div style={{ flex: 1, minWidth: '160px' }}>
                        <label style={ESTILO_ROTULO_FILTRO}>Buscar</label>
                        <input
                            className="form-control form-control-sm"
                            style={ESTILO_INPUT_FILTRO}
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') aplicar({}); }}
                            onBlur={() => { if ((filtros.search || '') !== busca) aplicar({}); }}
                            placeholder="Serviço, prestador, #id"
                        />
                    </div>
                    {temFiltro && (
                        <Button variant="link" size="sm" className="text-decoration-none px-1" onClick={limparFiltros}>Limpar</Button>
                    )}
                </div>

                <div style={{ overflowX: 'auto' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: grade, gap: '14px', padding: '10px 20px', borderBottom: '1px solid #e6ecf3', fontSize: '11px', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: '#8494a6', minWidth: '900px' }}>
                        <div>ID</div>
                        <div>Data</div>
                        <div>Serviço</div>
                        <div>Prestador</div>
                        <div>Status</div>
                        {recebeKit && <div>Kit</div>}
                        <div style={{ textAlign: 'right' }}>Ação</div>
                    </div>

                    {visiveis.length === 0 ? (
                        <div style={{ padding: '24px 20px', fontSize: '13px', color: '#6b7a8d' }}>Nenhum agendamento encontrado.</div>
                    ) : visiveis.map(ag => {
                        const encerrado = ['finalizado', 'cancelado'].includes(ag.situacao);
                        const podeConfirmar = !['finalizado', 'cancelado', 'arquivo_pendente'].includes(ag.situacao)
                            && (ag.status_aceite === 'aceito' || !ag.envia_aceite);
                        const servicoRel = ag.dados_servico_relacionado;
                        const exameVinc = ag.dados_exame_vinculado;
                        const kit = recebeKit ? resumoKit(ag) : null;

                        const podeGerarServico = podeVerVinculo && ag.situacao === 'finalizado' && !servicoRel
                            && (['', 'gestor', 'operador'].includes(dadosUsuario['tipo_usuario']) || dadosUsuario['is_superuser']);

                        // Mesmas condicoes da aba classica: cancelado nao aceita acao, e quando o
                        // agendamento exige aceite nada abre antes do prestador aceitar.
                        const liberadoParaAcoes = ag.situacao !== 'cancelado'
                            && ((ag.envia_aceite === true && ag.status_aceite === 'aceito') || !ag.envia_aceite);
                        const podeEditar = !encerrado && (perfil !== 'prestador' || podeEditarComoPrestador);
                        const podeVisualizar = !podeEditar && perfil !== 'prestador' && !!onVisualizar;
                        const aguardaAceite = habilitarAceiteRecusa && ag.envia_aceite === true;

                        // uma ação em destaque por linha, na ordem do ciclo; o resto vai para o menu
                        const acaoPrincipal = podeConfirmar ? 'confirmar'
                            : podeGerarServico ? 'gerar'
                            : (podeVerVinculo && podeVincularExame(ag)) ? 'vincular'
                            : null;

                        // datas secundárias saem da grade e viram tooltip da hora
                        const tituloData = [
                            ag.data_solicitacao ? `Solicitado em ${formataDataHoraExibicao(ag.data_solicitacao)}` : null,
                            ag.data_liberacao ? `Liberado em ${formataDataHoraExibicao(ag.data_liberacao)}` : null,
                            ag.data_cancelamento ? `Cancelado em ${formataDataHoraExibicao(ag.data_cancelamento)}` : null,
                        ].filter(Boolean).join(' · ');

                        const dataCompleta = semData(ag.data_agendamento) ? null : formataDataHoraExibicao(ag.data_agendamento);
                        const [dataDia, dataHora] = dataCompleta ? dataCompleta.split(', ') : ['—', ''];

                        return (
                            <div key={ag.id} style={{ display: 'grid', gridTemplateColumns: grade, gap: '14px', padding: '13px 20px', borderBottom: '1px solid #eef2f7', alignItems: 'center', minWidth: '900px', color: encerrado ? '#6b7a8d' : 'inherit' }}>
                                <div style={{ fontSize: '13px', fontWeight: 700, color: encerrado ? '#6b7a8d' : '#0f2748' }}>#{ag.id}</div>

                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontSize: '13px', fontWeight: 600, color: encerrado ? '#6b7a8d' : '#26364a' }}>{dataDia}</div>
                                    {dataHora && <div style={ESTILO_METADADO} title={tituloData}>{dataHora}</div>}
                                </div>

                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontSize: '13px', color: encerrado ? '#6b7a8d' : '#26364a' }}>{ag.dados_servico_procedimento?.nome || '-'}</div>
                                    {/* vínculos como texto cinza, nunca badge. O pedido é como a
                                        operação se refere ao exame, então aparece junto. */}
                                    {podeVerVinculo && (ag.exame_solicitado || servicoRel) && (
                                        <div style={ESTILO_METADADO}>
                                            {ag.exame_solicitado && (
                                                <span title={`Exame solicitado #${ag.exame_solicitado}${exameVinc?.pedido_id ? `, do pedido de exame #${exameVinc.pedido_id}` : ''}`}>
                                                    · exame #{ag.exame_solicitado}
                                                    {exameVinc?.pedido_id && ` · pedido #${exameVinc.pedido_id}`}
                                                </span>
                                            )}
                                            {ag.exame_solicitado && servicoRel && ' '}
                                            {servicoRel && <span title={`Serviço relacionado (faturável) #${servicoRel.id}`}>· serviço #{servicoRel.id}</span>}
                                        </div>
                                    )}
                                </div>

                                <div style={{ fontSize: '13px', color: encerrado ? '#6b7a8d' : '#26364a', minWidth: 0 }}>
                                    {ag.dados_prestador?.nome || <span style={ESTILO_METADADO}>não atribuído</span>}
                                </div>

                                <div style={{ minWidth: 0 }}>
                                    {/* badge colorido (mesma classe da aba atual): agora é o único
                                        elemento com cor forte na linha, então destaca sem competir */}
                                    <span className={`badge-agendamento badge-status-${ag.situacao}`}>
                                        {situacoesAgendamento[ag.situacao] || ag.situacao}
                                    </span>
                                    {aguardaAceite && (
                                        <div className="mt-1">
                                            <span className={`badge-aceite badge-aceite-${(ag.status_aceite || 'aguardando').toLowerCase()}`} title="Status do aceite/recusa">
                                                {(ag.status_aceite || 'aguardando').replace(/^./, c => c.toUpperCase())}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {recebeKit && (
                                    <div style={{ fontSize: '12px', color: '#4a5a6b', minWidth: 0 }} title={kit.titulo}>{kit.texto}</div>
                                )}

                                {/* A ação principal do momento fica visível; as demais ficam no menu,
                                    que reúne tudo que a aba clássica oferece. */}
                                <div className="d-flex justify-content-end align-items-center" style={{ gap: '4px', minWidth: 0 }}>
                                    {acaoPrincipal === 'confirmar' && (
                                        <Button variant="outline-success" size="sm" onClick={() => onConfirmarRealizacao(ag)}>Confirmar Realização</Button>
                                    )}
                                    {acaoPrincipal === 'gerar' && (
                                        <Button variant="outline-secondary" size="sm" onClick={() => onGerarServico(ag)}>Gerar serviço</Button>
                                    )}
                                    {acaoPrincipal === 'vincular' && (
                                        <Button variant="outline-secondary" size="sm" onClick={() => onVincularExame(ag)}>
                                            <FaLink className="me-1" /> Vincular exame
                                        </Button>
                                    )}

                                    <Dropdown align="end">
                                        <Dropdown.Toggle variant="outline-secondary" size="sm" id={`acoes-ag-${ag.id}`} title="Mais ações" />
                                        <Dropdown.Menu>
                                            {podeEditar && (
                                                <Dropdown.Item onClick={() => onEditar(ag)}>
                                                    <FaRegEdit className="me-2" /> Editar agendamento
                                                </Dropdown.Item>
                                            )}

                                            {podeVisualizar && (
                                                <Dropdown.Item onClick={() => onVisualizar(ag)}>
                                                    <FaEye className="me-2" /> Visualizar agendamento
                                                </Dropdown.Item>
                                            )}

                                            {liberadoParaAcoes && onArquivos && (
                                                <Dropdown.Item onClick={() => onArquivos(ag)}>
                                                    <FaFileAlt className="me-2" /> Arquivos
                                                </Dropdown.Item>
                                            )}

                                            {onMonitoramento && !encerrado
                                                && (ag.dados_servico_procedimento?.servico_dados_monitoramento
                                                    || (ag.dados_servico_procedimento?.nome || '').startsWith('Monitoria')) && (
                                                <Dropdown.Item onClick={() => onMonitoramento(ag)}>
                                                    <FaChartLine className="me-2" /> Dados de monitoramento
                                                </Dropdown.Item>
                                            )}

                                            {/* sempre disponivel, como na aba classica: e por aqui que se
                                                registra a primeira anotacao, nao so as que ja existem */}
                                            {liberadoParaAcoes && onAnotacoes && (
                                                <Dropdown.Item onClick={() => onAnotacoes(ag)}>
                                                    <FaRegStickyNote className="me-2" /> Anotações
                                                </Dropdown.Item>
                                            )}

                                            {onAtribuirPrestador && !encerrado && (
                                                <Dropdown.Item onClick={() => onAtribuirPrestador(ag)}>
                                                    <FaUserPlus className="me-2" /> {ag.prestador_id ? 'Trocar prestador' : 'Atribuir prestador'}
                                                </Dropdown.Item>
                                            )}

                                            {onFormularioDinamico && mostrarFormularioDinamico(ag) && !encerrado && (
                                                <Dropdown.Item onClick={() => onFormularioDinamico(ag)}>
                                                    <FaClipboardList className="me-2" /> Formulário do serviço
                                                </Dropdown.Item>
                                            )}

                                            {/* vincular exame e gerar serviço continuam alcançáveis quando
                                                não são a ação principal da linha */}
                                            {podeVerVinculo && podeVincularExame(ag) && acaoPrincipal !== 'vincular' && (
                                                <Dropdown.Item onClick={() => onVincularExame(ag)}>
                                                    <FaLink className="me-2" /> Vincular exame
                                                </Dropdown.Item>
                                            )}

                                            {podeGerarServico && acaoPrincipal !== 'gerar' && (
                                                <Dropdown.Item onClick={() => onGerarServico(ag)}>
                                                    <FaClipboardList className="me-2" /> Gerar serviço faturável
                                                </Dropdown.Item>
                                            )}

                                            {/* Aceite/recusa e despesas so existem nos programas que
                                                habilitam essas configuracoes (ex.: rede credenciada). */}
                                            {ag.situacao !== 'cancelado' && ag.envia_aceite === true && (
                                                <>
                                                    <Dropdown.Divider />
                                                    {habilitarAceiteRecusa && ag.status_aceite === 'aguardando' && onAceite && (
                                                        <Dropdown.Item onClick={() => onAceite(ag, true)}>
                                                            <FaCheck className="me-2" /> Aceitar agendamento
                                                        </Dropdown.Item>
                                                    )}
                                                    {habilitarAceiteRecusa && !encerrado && ag.status_aceite !== 'recusado' && onAceite && (
                                                        <Dropdown.Item onClick={() => onAceite(ag, false)}>
                                                            <FaTimes className="me-2" /> Recusar agendamento
                                                        </Dropdown.Item>
                                                    )}
                                                    {onHistoricoAceites && (['', 'gestor', 'operador'].includes(perfil) || dadosUsuario['is_superuser']) && (
                                                        <Dropdown.Item onClick={() => onHistoricoAceites(ag)}>
                                                            <FaHistory className="me-2" /> Histórico aceites/recusas
                                                        </Dropdown.Item>
                                                    )}
                                                </>
                                            )}

                                            {habilitarDespesas && liberadoParaAcoes && onDespesas && (
                                                <Dropdown.Item onClick={() => onDespesas(ag)}>
                                                    <FaReceipt className="me-2" /> Despesas
                                                </Dropdown.Item>
                                            )}

                                            {onExcluir && ag.situacao === 'cancelado' && hasPerm('delete_agendamentos') && (
                                                <>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item className="text-danger" onClick={() => onExcluir(ag)}>
                                                        <FaTrash className="me-2" /> Excluir agendamento
                                                    </Dropdown.Item>
                                                </>
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                {/* sala de vídeo e link do paciente, nas mesmas condições das outras telas */}
                                {ag.dados_meeting?.whereby_sala_url && !agendamentoEncerrado(ag.situacao) && (
                                    <div style={{ gridColumn: '1 / -1', display: 'flex', gap: '6px', flexWrap: 'wrap', paddingTop: '8px' }}>
                                        <Button variant="secondary" size="sm" href={`/meetings/view/${ag.id}`}>Vídeo Conferência</Button>
                                        <AcoesLinkPaciente
                                            link={ag.dados_meeting.whereby_sala_url}
                                            agendamentoId={ag.id}
                                            emailPaciente={emailPaciente}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                {totalPaginas > 1 && (
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2" style={{ padding: '12px 20px', borderTop: '1px solid #e6ecf3' }}>
                        <div style={{ fontSize: '12px', color: '#6b7a8d' }}>
                            Página {pagina} de {totalPaginas} · {total} {total === 1 ? 'agendamento' : 'agendamentos'}
                        </div>
                        <div className="d-flex gap-2">
                            <Button variant="outline-secondary" size="sm" disabled={pagina <= 1 || carregando} onClick={() => onPagina && onPagina(pagina - 1)}>
                                Anterior
                            </Button>
                            <Button variant="outline-secondary" size="sm" disabled={pagina >= totalPaginas || carregando} onClick={() => onPagina && onPagina(pagina + 1)}>
                                Próxima
                            </Button>
                        </div>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default AgendamentosBeta;
